var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUnknown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 70,
    viewBox: "0 0 94 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 0L93.823 0 93.823 69.55 0 69.55z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 .033)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#77869e",
    d: "M90.872 44.017c0 4.77-3.874 8.65-8.636 8.65h-3.795V25.533c0-6.4-5.197-11.605-11.586-11.605H18.332v-2.321c0-4.77 3.874-8.65 8.635-8.65h55.27c4.761 0 8.635 3.88 8.635 8.65v32.41zm-15.38 13.927c0 4.77-3.875 8.65-8.637 8.65H11.587c-4.762 0-8.636-3.88-8.636-8.65V38.91h72.54v19.033zM2.95 35.955h72.54V29.29H2.95v6.665zm8.636-19.072h55.268c4.762 0 8.636 3.88 8.636 8.65v.801H2.951v-.802c0-4.77 3.874-8.65 8.636-8.65zM82.237 0h-55.27C20.58 0 15.381 5.207 15.381 11.606v2.321h-3.794C5.197 13.927 0 19.133 0 25.532v32.412C0 64.343 5.198 69.55 11.587 69.55h55.268c6.389 0 11.586-5.207 11.586-11.606v-2.32h3.795c6.39 0 11.587-5.207 11.587-11.607V11.606C93.823 5.206 88.625 0 82.236 0z",
    mask: "url(#prefix__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77869e",
    d: "M62 55.833c-2.132 0-3.867-1.734-3.867-3.866S59.868 48.1 62 48.1c2.132 0 3.867 1.735 3.867 3.867 0 2.132-1.735 3.866-3.867 3.866m0-10.866c-3.86 0-7 3.14-7 7s3.14 7 7 7c3.859 0 7-3.14 7-7s-3.141-7-7-7",
    mask: "url(#prefix__b)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#77869e",
    fontFamily: "Montserrat-Bold, Montserrat",
    fontSize: 16,
    fontWeight: "bold",
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 57.967
  }, "UN")))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnknown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/unknown.ca22d397.svg";
export { ForwardRef as ReactComponent };